export default __webpack_public_path__ + "static/media/yearbook-back.5167b067.jpg";